/** A stable id and a human name for this browser, so playback can move between devices. */

const KEY = 'vb.device';

export function deviceId(): string {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return 'nostorage';
  }
}

export function deviceName(): string {
  const ua = navigator.userAgent;
  const touch = navigator.maxTouchPoints > 1;
  let kind = 'Computer';
  if (/iPhone/.test(ua)) kind = 'iPhone';
  else if (/iPad/.test(ua) || (/Macintosh/.test(ua) && touch)) kind = 'iPad';
  else if (/Android/.test(ua)) kind = /Mobile/.test(ua) ? 'Android phone' : 'Android tablet';
  else if (/Macintosh|Mac OS X/.test(ua)) kind = 'Mac';
  else if (/Windows/.test(ua)) kind = 'Windows PC';
  else if (/CrOS/.test(ua)) kind = 'Chromebook';
  else if (/Linux/.test(ua)) kind = 'Linux PC';
  let browser = 'Browser';
  if (/VideoBridgeAndroid\//.test(ua)) browser = 'App';
  else if (/Edg\//.test(ua)) browser = 'Edge';
  else if (/Firefox\//.test(ua)) browser = /Zen/.test(ua) ? 'Zen' : 'Firefox';
  else if (/OPR\//.test(ua)) browser = 'Opera';
  else if (/Chrome\//.test(ua)) browser = 'Chrome';
  else if (/Safari\//.test(ua)) browser = 'Safari';
  return `${kind} · ${browser}`;
}
